import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, Row, Spinner, Table } from 'react-bootstrap';
import { CursosExternosService } from '../../../../service/cursosExternos.service';
import { CompletitudesExternoResponse } from '../../../../service/types/cursosExternos.types';

interface CompletitudesExternoManagerProps {
  cursoExternoId: string;
}

export default function CompletitudesExternoManager({ cursoExternoId }: CompletitudesExternoManagerProps) {
  const [completitudes, setCompletitudes] = useState<CompletitudesExternoResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelado = false;
    setLoading(true);
    CursosExternosService.getCompletitudes(cursoExternoId)
      .then((data) => {
        if (!cancelado) setCompletitudes(data);
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });
    return () => {
      cancelado = true;
    };
  }, [cursoExternoId]);

  if (loading) {
    return (
      <div className="text-center py-4">
        <Spinner animation="border" size="sm" /> Cargando completitudes...
      </div>
    );
  }

  const completados = completitudes?.completados ?? [];
  const pendientes = completitudes?.pendientes ?? [];

  return (
    <Row>
      <Col md={7} className="mb-3">
        <Card className="shadow-sm h-100">
          <Card.Header className="bg-success text-white d-flex justify-content-between align-items-center">
            <span>Completaron el curso externo</span>
            <Badge bg="light" text="dark">
              {completados.length}
            </Badge>
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive size="sm" className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Usuario</th>
                  <th>RUT</th>
                  <th>Completado el</th>
                  <th>Firma</th>
                  <th>Evidencia</th>
                </tr>
              </thead>
              <tbody>
                {completados.map((u) => (
                  <tr key={u.rut}>
                    <td>{u.name}</td>
                    <td>{u.rut}</td>
                    <td>{u.completadoEn ? new Date(u.completadoEn).toLocaleDateString() : '-'}</td>
                    <td>
                      {u.firma ? (
                        <img src={u.firma} alt="Firma" style={{ maxWidth: '150px', maxHeight: '80px' }} />
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>
                      {u.archivoUrl ? (
                        <a href={'/api' + u.archivoUrl} target="_blank" rel="noopener noreferrer">
                          Descargar
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                ))}
                {completados.length === 0 && (
                  <tr>
                    <td colSpan={5} className="text-center text-muted">
                      Nadie ha completado este curso externo aún
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      <Col md={5} className="mb-3">
        <Card className="shadow-sm h-100">
          <Card.Header className="bg-warning text-dark d-flex justify-content-between align-items-center">
            <span>Pendientes</span>
            <Badge bg="light" text="dark">
              {pendientes.length}
            </Badge>
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive size="sm" className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Usuario</th>
                  <th>RUT</th>
                </tr>
              </thead>
              <tbody>
                {pendientes.map((u) => (
                  <tr key={u.rut}>
                    <td>{u.name}</td>
                    <td>{u.rut}</td>
                  </tr>
                ))}
                {pendientes.length === 0 && (
                  <tr>
                    <td colSpan={2} className="text-center text-muted">
                      No hay usuarios pendientes
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
